import { OfferPaymentType } from "@pathwright/graphql-client/src/generated"

export enum RegistrationOfferingOption {
  InPlan = 1,
  NotInPlan = 2
}

export function getOfferingOptionForPaymentType(paymentType?: string | null) {
  if (!paymentType) return null
  return paymentType.toUpperCase() === OfferPaymentType.Subscription
    ? RegistrationOfferingOption.InPlan
    : RegistrationOfferingOption.NotInPlan
}

export function getOfferPaymentTypeForOfferingOption(
  options: { payment_type?: OfferPaymentType | null }[],
  offeringOption: number
) {
  return (
    options.find(
      ({ payment_type }) =>
        !!payment_type &&
        getOfferingOptionForPaymentType(payment_type) === offeringOption
    )?.payment_type ?? null
  )
}

export function getOfferConversionPanelPath(
  offerId: number,
  paymentType?: OfferPaymentType | null
) {
  return `access/offer/${offerId}/${
    paymentType ? `${paymentType.toLowerCase()}/` : ""
  }`
}
